import * as React from "react";

function RocketIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: props.color || 'current',
    viewBox: "0 0 15 15",
    "aria-hidden": "true",
    width: props.width || '32px'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_287_33485)",
    d: "M11.744 8.677c2.32-2.768 2.912-6.624 2.848-7.792a.533.533 0 00-.144-.336.468.468 0 00-.336-.144C12.944.34 9.088.917 6.336 3.237l-.64-.24a2.836 2.836 0 00-3.152.832L.768 5.925a.551.551 0 00.24.88l1.904.704a18.796 18.796 0 00-.896 1.712.886.886 0 00.192 1.008l2.56 2.576a.898.898 0 001.008.176c.416-.192 1.008-.48 1.712-.896l.688 1.904c.128.368.592.48.88.24l2.08-1.776a2.836 2.836 0 00.832-3.152l-.224-.624zm-1.2-2c-.608.608-1.6.608-2.224 0a1.584 1.584 0 010-2.224 1.584 1.584 0 012.224 0 1.584 1.584 0 010 2.224z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_287_33485",
    x1: 14.508,
    x2: 2.111,
    y1: 0.262,
    y2: 14.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED801F"
  }))));
}

export default RocketIcon;